module.exports = __webpack_public_path__ + "static/media/6.4dcca766.jpg";